import {useIsLoggedIn, useLocation} from '@/hooks';
import {useRouter} from 'next/navigation';
import {useEffect, useState} from 'react';
import {useRedeemStepsContext} from '@/context/RedeemStepsContext';
import {isTalonEnabled, isTalonReady} from '@/lib/utils/page.utils';
import {useSiteSettingsContext} from '@/context/SiteSettingsContext';

export const useAutoRedeem = (trigger: () => Promise<any>): boolean => {
	const {code} = useRedeemStepsContext();
	const {cmsRedeemDisabled} = useSiteSettingsContext();
	const router = useRouter();
	const isLoggedIn = useIsLoggedIn();
	const location = useLocation();
	const autoRedeem = location.searchParams.get('autoRedeem') === 'true';
	const [redeeming, setRedeeming] = useState(false);

	let shouldRedeem =
		isLoggedIn && autoRedeem && !!code && typeof trigger === 'function' && !cmsRedeemDisabled;

	if (shouldRedeem && isTalonEnabled()) {
		shouldRedeem = isTalonReady();
	}

	useEffect(() => {
		if (redeeming) return;

		if (shouldRedeem) {
			try {
				setRedeeming(true);

				trigger()
					.catch((err) => console.error(err))
					.finally(() => {
						setRedeeming(false);
					});

				location.url.searchParams.delete('autoRedeem');
				router.replace(location.url.toString());
			} catch {
				console.log('Failed to clear autoRedeem param');
			}
		}
	}, [shouldRedeem]);

	return redeeming;
};
